import {
    apiIndiceList,
    apiIndicePerf,
    apiIndicesNav,
    apiIndiceQuote
  } from "../../api/indice.js";
import * as constant from "./constant";
import moment from "moment";
const arrPeriod = ["1D", "1M", "3M", "6M", "1Y"];
const objPeriod = {
    "1D": {
        count: 1,
        typeOfPeriod: "day"
    },
    "1W": {
        count: 1,
        typeOfPeriod: "week"
    },
    "1M": {
        count: 1,
        typeOfPeriod: "month"
    },
    "3M": {
        count: 3,
        typeOfPeriod: "months"
    },
    "6M": {
        count: 6,
        typeOfPeriod: "months"
    },
    "1Y": {
        count: 1,
        typeOfPeriod: "year"
    },
    "3Y": {
        count: 3,
        typeOfPeriod: "years"
    },
    "5Y": {
        count: 5,
        typeOfPeriod: "years"
    },
    "10Y": {
        count: 10,
        typeOfPeriod: "years"
    },
};
export const actions = {
    async setReturnPeriod({ commit }, payload) {
        await commit(constant.INDICE_PRICE, payload);
    },
    async findIndiceShareData({ commit }, { stockName }) {
       
        let arrData = [];
        for (let i = 0; i < arrPeriod.length; i++) {
            const { count, typeOfPeriod } = objPeriod[arrPeriod[i]];
            let to = moment().unix();
            let from = moment()
                .subtract(count, typeOfPeriod)
                .unix();
           
            await commit(constant.INDICE_TIMESTAMP_1D, { to: to, from: from });
            const obj = {
                stockName,
                to: to,
                from: from
            };
            const rs = await apiIndicesNav(obj);
            if (rs && rs.status == 200) {
                let data = rs.data;
                if (data) {
                    arrData.push(data);
                }
            }
        }
        await commit(constant.INDICE_NAV_SHARE, arrData);
    },
    async findIndiceNav({ commit, getters }, { stockName, period }) {
        let to = moment().unix();
        let from = moment().subtract(1, "years").unix();
        switch (period) {
            case "YTD":
                from = moment().startOf('years').unix()
                break;
            case 'MAX':
                from = moment("1950-01-01T00:00:00").unix()
                break;
            default:
                const { count, typeOfPeriod } = objPeriod[period];
                from = moment().subtract(count, typeOfPeriod).unix();
                break;
        }

        if (period == "1D" && getters.getIndiceQuote) {
            let lastDataDate = getters.getIndiceQuote.date.split("/");
            let tranfromDate = lastDataDate[1] + "/" + lastDataDate[0] + "/" + lastDataDate[2];
            let targetDate = new Date(tranfromDate);
            to = targetDate.getTime() / 1000;
            targetDate.setDate(targetDate.getDate() - 2);
            from = targetDate.getTime() / 1000;
        }
        const obj = {
            stockName,
            to: to,
            from: from,
            period: period
        };
        const rs = await apiIndicesNav(obj);
        if (rs && rs.status == 200) {
            let data = rs.data;
            if (data) {
                await commit(constant.INDICE_NAV, data);
            }
        }
    },
    async findIndiceList({ commit }) {
        const rs = await apiIndiceList();
        if (rs && rs.status == 200) {
            let data = rs.data;
            if (data) {
                let arr = []
                for (let i = 0; i < data.length; i++) {
                    if(data[i].SecurityID !== -42){
                        arr.push(data[i])
                    }
                }
                await commit(constant.INDICE_LIST, arr);
            }
        }
    },
    async findIndiceRanking({ commit }, period) {
        const rs = await apiIndicePerf();
        if (rs && rs.status == 200) {
            let data = rs.data;
            if (data) {
                await commit(constant.INDICE_RANKING, { payload: data, period });
            }
        }
    },
    async findIndiceQuote({ commit, state }, params) {
        if (state.indiceQuote.name === params) return true; // user select current data
        if (params) params = params.toUpperCase();
        const rs = await apiIndiceQuote(params);
        if (rs && rs.status == 200) {
            let data = rs.data;
            if (data && typeof data !== "string") {
                await commit(constant.INDICE_QUOTE, data);
                return true;
            }
            return false;
        }
    },
    async findIndiceFollowing({ commit }) {
        let mockData = [
            {
                name: "SET",
                data_date: "2019-01-01",
                price: 1609,
                period: "1D",
                percent: -2.0
            },
            {
                name: "SET50",
                data_date: "2019-01-01",
                price: 109,
                period: "1D",
                percent: 1.22
            }
        ];
        await commit(constant.INDICE_FOLLOWING, mockData);
    },
    async updateIndiceFollowing({ commit }, payload) {
        await commit(constant.INDICE_FOLLOWING, payload);
    }
};
